import React from 'react';

import { A11yWrapper } from 'components/ui/a11y-wrapper';
import { Typography, TypographyProps } from 'components/ui/typography';
import { t } from 'state/intl/translations';

import { Total, TotalLabel, TotalsRow } from './styled';

export const TaxesAndFeesNextStep: React.FC<React.PropsWithChildren<{
  textProps?: TypographyProps;
}>> = ({ textProps }) => {
  return (
    <TotalsRow>
      <A11yWrapper>
        <TotalLabel {...(textProps && { fontSize: 'sm' })}>{t('taxesAndFees')}</TotalLabel>
      </A11yWrapper>
      <Total testID="totalTax">
        <Typography {...(textProps && { fontSize: 'sm' })}>{t('taxesAndFeesNextStep')}</Typography>
      </Total>
    </TotalsRow>
  );
};
